import React, {useState} from "react";
import {useGetHeatsForTournament} from "../heat/heatHooks";
import { useTournamentStore } from '../../service/useTournamentStore';
import {useTranslation} from "react-i18next";

interface HeatSelectorProps {
    onSelect: (id: number) => void;
}

const HeatSelector: React.FC<HeatSelectorProps> = ({onSelect}) => {
    const {t} = useTranslation();
    const {selectedTournament} = useTournamentStore();
    const {data: series, isLoading} = useGetHeatsForTournament(selectedTournament!.id);
    const [selectedHeat, setSelectedHeat] = useState<number | undefined>(undefined);

    const handleSelect = (event: React.ChangeEvent<HTMLSelectElement>) => {
        const value = event.target.value;
        const heatId = value ? Number(value) : undefined;
        onSelect(heatId!); // undefined si aucune sélection valide
        setSelectedHeat(heatId);
    };


    if (isLoading) return <p>Loading series...</p>;

    return (
        <div className="select-wrapper">
            <select
                onChange={handleSelect}
                value={selectedHeat ?? ""}>
                <option value="">{t('HEAT_SELECTOR_TITLE')}</option>
                {series?.map((heat) => (
                    <option key={heat.id} value={heat.id}>
                        {heat.name}
                    </option>
                ))}
            </select>
        </div>

    );
};

export default HeatSelector;